import {
  ChannelType,
  IAPIChannel,
  IAPIProgram,
  IChannel,
  IProgram,
  ProgramState,
} from './types';

export function apiChannelToChannel(
  apiChannel: IAPIChannel,
  getNextProgram: IChannel['getNextProgram'],
  categoryId: number
): IChannel {
  const type = getChannelType(apiChannel);

  const channel: IChannel = {
    id: apiChannel.id,
    title: apiChannel.title,
    type,
    isLocked: getIsChannelLocked(apiChannel),
    currentProgram: null,
    image: apiChannel.image.small,
    originalGenre: { id: categoryId },
    isProgramAllocated: true,
    isInteractive:
      type === ChannelType.DVR_CHANNEL || type === ChannelType.VOD_CHANNEL,
    getNextProgram,
    getPrevProgram: () => null,
    _programs: [],
    get programs() {
      return this._programs;
    },
    _programsMap: new Map(),
    _addProgram(program) {
      if (!this._programsMap.has(program.startTimestamp)) {
        this._programsMap.set(program.startTimestamp, program);
      }
      this._programs.push(program);
    },
  };

  return channel;
}

function getChannelType(apiChannel: IAPIChannel): ChannelType {
  let result: ChannelType;
  if (apiChannel.vod_channel) {
    result = ChannelType.VOD_CHANNEL;
  } else if (apiChannel.is_dvr) {
    result = ChannelType.DVR_CHANNEL;
  } else {
    result = ChannelType.REGULAR_CHANNEL;
  }
  return result;
}

function getIsChannelLocked(apiChannel: IAPIChannel): boolean {
  return !apiChannel.is_available && !apiChannel.free;
}

export function apiProgramToProgram(data: {
  apiProgram: IAPIProgram;
  parentChannel: IChannel;
  getProgramState: () => ProgramState;
}): IProgram {
  const { apiProgram, parentChannel, getProgramState } = data;

  const program: IProgram = {
    id: apiProgram.id,
    title: apiProgram.title,
    startTimestamp: apiProgram.start_timestamp,
    endTimestamp: apiProgram.end_timestamp,
    channel: parentChannel,
    duration: apiProgram.end_timestamp - apiProgram.start_timestamp,
    state: getProgramState(),
    virtualObjectId: apiProgram.virtual_object_id,
    objectId: apiProgram.object_id,
    virtualStream: null,
    groupedPrograms: apiProgram.grouped_programs,
  };

  return program;
}

export function getProgramState(data: {
  start: number;
  end: number;
  current: number;
}): ProgramState {
  const { start, end, current } = data;
  let state: ProgramState;

  if (end < current) {
    state = ProgramState.PAST;
  } else if (start <= current && end >= current) {
    state = ProgramState.CURRENT;
  } else {
    state = ProgramState.FUTURE;
  }

  return state;
}
